import branchManagementRestoreRouteAssignmentsComponent from './restore_route_assignments.component';

let branchManagementRestoreRouteAssignmentsModule = angular.module('branchManagementRestoreRouteAssignments', [])
    .component('branchManagementRestoreRouteAssignments', branchManagementRestoreRouteAssignmentsComponent)
    .name;

export default branchManagementRestoreRouteAssignmentsModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/restore_route_assignments/index.js